<template>
    <Card>
        <template #title>
            <Toolbar>
                <template #left>
                    <div class="p-card-title"> API LOG</div>
                </template>
            </Toolbar>
        </template>
        <template #content>
            <div class="p-inputtext-sm p-fluid">
                <div class="grid">
                    <div class="col-12">
                        <FormField fieldName="Trigger_Code" :labelName="$t('Trigger_Code')" v-model="header"
                            fieldClass="col-3" labelClass="col-2" v-if="header" >
                            <CustomSelect 
                                        class="p-inputtext-sm"
                                        name="Trigger_Code"
                                        v-model="header.Trigger_Code"
                                        :url="$API_URL + 'list/lookup'"
                                        :params="{ group: this.$LOOKUP_GROUP.API_TRIGGER_LOG }"
                                        :minLength="0"
                                        :filter="true"
                                        :placeholder="$t('Trigger_Code')"
                                        />
                                    <small v-if="submitted && !header.Trigger_Code" 
                                        class="p-error">{{ $t('required_field') }}
                                    </small>
                        </FormField>
                    </div>
                    <div class="col-12">
                        <div class="grid">
                            <div class="col-2">
                                <span>{{$t('Doc_Date_From')}}</span>
                            </div>
                                <div class="col-3 md-3">
                                    <DatePicker name="Doc_Date_From" v-model="header.Doc_Date_From" :placeholder="$t('Doc_Date_From')"  
                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY" />
                                        <small v-if="submitted && !header.Doc_Date_From" class="p-error">
                                        {{ $t('required_field') }}
                                        </small>
                                </div>

                                <label for="Doc_Date_To" class="col-1">{{$t('to')}}</label>
                                <div class="col-3 md-3">
                                    <DatePicker name="Doc_Date_To" v-model="header.Doc_Date_To" :placeholder="$t('to_date')" 
                                        dateFormat="dd/mm/yyyy" inputMask="99/99/9999" momentFormat="DD/MM/YYYY"/>
                                    <small v-if="submitted && !header.Doc_Date_To" 
                                        class="p-error">{{ $t('required_field') }}
                                    </small>
                                </div>
                        </div>

                    </div>
                </div>
            </div>
            <Button type="button" label="Generate" @click="getAPILogList()" />
            &nbsp;
            <Button type="button" class="p-button-success" label="Reopen" @click="reopenTab()"
                v-show="this.reportTbl" />
        </template>
    </Card>
    <ShowList :isVisible="showList" :reportTbl="this.reportTbl" @close="resetBtn()" />
</template>

<script type="text/javascript">
import IndexBase from '../Helper/IndexBase.vue';
import FormField from "../Helper/FormField.vue";
import ShowList from "../APILog/ShowList.vue";

export default {
    name : "APILog",
    components: {
        'IndexBase': IndexBase,
    },
    data(){
        return{
            dataUrl: "APILog/Index",
            header: {
                Trigger_Code: null,
                Doc_Date_From: null,
                Doc_Date_To: null,
            },
             submitted: false,
        };
    },
    methods:{
        getAPILogList() {
        this.submitted = true;
        if (!this.header.Doc_Date_From || !this.header.Doc_Date_To || !this.header.Trigger_Code) {
            this.$emit("unblock-ui");
            return;
        }

        // Konversi date ke ISO (atau format lain sesuai backend)
        const payload = { ...this.header };
        if (payload.Doc_Date_From instanceof Date) {
            payload.Doc_Date_From = payload.Doc_Date_From.toISOString();
        }
        if (payload.Doc_Date_To instanceof Date) {
            payload.Doc_Date_To = payload.Doc_Date_To.toISOString();
        }

        // 👉 hanya redirect, bawa param di query
        this.$router.push({
            path: "/APILog/ShowList",
            query: payload
        });
        },
        reopenTab(){
            this.showList = true;
        },
        resetBtn(){
            this.showList = false;
        },
        showError() {
            this.loadingReport = !this.loadingReport;
        },
        closeReport() {
            this.showReport = false;
        },
        loadLazyData(){
            this.loading = false;
            this.Doc_Date_From = JSON.parse(localStorage.getItem('Doc_Date_From'));
            this.Doc_Date_To = JSON.parse(localStorage.getItem('Doc_Date_To'));
        }
    }
}
</script>
<style #scoped>
.p-card .p-card-content {
    margin: 0 !important;
    padding: 0 !important;
}
/* .custom-select {
  min-height: 30px !important;
} */
</style>